import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import TypeWriter from 'react-typewriter';

import { socialLinks } from '../../utils/socialLinks';
import {
  socialAnimation,
  socialTransition,
  greetAnimation,
  greetTransition,
  nameAnimation,
  nameTransition,
  occAnimation,
  occTransition,
  buttonAnimation,
  buttonTransition,
} from '../../animations/home';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <div className="home__wrapper">
        <motion.div
          className="home__socials"
          initial="out"
          animate="in"
          variants={socialAnimation}
          transition={socialTransition}
        >
          {socialLinks.map((link) => {
            const { id, url, icon } = link;
            return (
              <a key={id} href={url}>
                {icon}
              </a>
            );
          })}
        </motion.div>

        <div className="home__info">
          <motion.p
            className="home__greeting"
            initial="out"
            animate="in"
            variants={greetAnimation}
            transition={greetTransition}
          >
            Hello I'm
          </motion.p>

          <motion.p
            className="home__name"
            initial="out"
            animate="in"
            variants={nameAnimation}
            transition={nameTransition}
          >
            Ken White
          </motion.p>

          <TypeWriter typing={0.3}>
            <motion.p
              className="home__occupation"
              initial="out"
              animate="in"
              variants={occAnimation}
              transition={occTransition}
            >
              A <span>Software Developer</span> based in Nairobi.
            </motion.p>
          </TypeWriter>

          <motion.div
            className="home__buttons"
            initial="out"
            animate="in"
            variants={buttonAnimation}
            transition={buttonTransition}
          >
            <Link className="home__button" to="/work">
              See my work
            </Link>
            <Link className="home__button" to="/contact">
              Contact me
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Home;
